import Stages from './Stages'
import { useQuery } from '@apollo/client'
import { CubeLoader } from '@/components/ui/cube-loader'
import { GET_AUDIENCES } from '@/graphql/audience-queries'
import { useAudienceDataWithHypotheses } from '@/hooks/useAudiencesWithHypotheses'
import { getAllStages } from '@/utils/ad-campaigns-helpers'
import { useWizard } from '@/components/common/wizard/WizardContext'

const ManualBudget = ({ selectedObjective, availableStages, store, currency }) => {
    const { getStepContentData } = useWizard()
    const salesFunnelSetupData = getStepContentData('salesFunnelSetup') || {}
    const audienceSelections = salesFunnelSetupData.audienceSelections || {}
    const allStages = getAllStages()
    const { data: catalogueAudiencesData, loading: audiencesLoading } = useQuery(GET_AUDIENCES)
    const audiencesData = useAudienceDataWithHypotheses(catalogueAudiencesData, getStepContentData)
    const audiences = audiencesData?.Audience?.audiences || []

    if (audiencesLoading) return (
        <div className="tw:w-full tw:flex tw:items-center tw:justify-center">
            <CubeLoader size="default" />
        </div>
    )

    return (
        <div>
            <Stages
                store={store}
                currency={currency}
                allStages={allStages}
                audiences={audiences}
                availableStages={availableStages}
                audienceSelections={audienceSelections}
                selectedObjective={selectedObjective}
            />
        </div>
    )
}

export default ManualBudget
